import React from "react";
import styles from "./Empty.module.scss";
import {ReactComponent as EmptyIcon} from "../../assets/icons/orders.svg";

const Empty = () => (
    <EmptyIcon className={styles.empty} />
)

export default Empty;
